import {Button, CircularProgress, Grid, Paper, Typography, useTheme} from '@mui/material';
import {useQuery} from '@tanstack/react-query';
import axios from 'axios';
import React, {useContext, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import QRCode from 'react-qr-code';
import {useNavigate} from 'react-router-dom';
import {useRecoilState} from 'recoil';
import SectionHeader from '../../../../util/component/SectionHeader';
import {GlobalContext} from '../../../../util/state/GlobalContextProvider';
import {snackbarTypes} from '../../../../util/state/globalVariables';
// import ActionValidation from '../../component/common/ActionValidation';
import {
  CUSTOMER_SELECTED_MOBILITY,
  ORDER_SELECTED,
  STEPPER_STATE,
  SUBSCRIPTION_SELECTED
} from '../../service/MobilityVoucherRecoil';
import {useVoucherActions} from '../../service/useMobilityVoucherAction';


const PaymentOrder = () => {
  const { t } = useTranslation(['mobilityvoucher']);

  return (
    <>
      <Paper elevation={1} sx={{ padding: "", margin: "18px" }}>
        <SectionHeader title={t('stepper.steps.title4')}
          subtitle={t('stepper.steps.subtitle4')} />

        <LoadingPayment />
      </Paper>
    </>
  );
};

export default PaymentOrder;


const LoadingPayment = (props: any) => {
    const theme = useTheme();
    const { t } = useTranslation(['mobilityvoucher']);
    const navigate = useNavigate();
    const [customer, setCustomer] = useRecoilState(CUSTOMER_SELECTED_MOBILITY);
    const [subscription, setSubscription] = useRecoilState(SUBSCRIPTION_SELECTED);
    const [activeStep, setActiveStep] = useRecoilState(STEPPER_STATE);
    const [order, setOrder] = useRecoilState(ORDER_SELECTED);
    const [payFalse, setPayFalse] = useState(false);
    const goToHome = () => {
      navigate('/mobilityvoucher/orders')
      setActiveStep((prevActiveStep: number) => 0);
    }
    const { raPreAuthPaymentDispositive,raPreAuthPaymentVerify, invoiceDraft, updatePayedOrder } = useVoucherActions();
  
    // Use Context
      const { dispatchGlobalData } = useContext(GlobalContext);
  
    // Payloads
      const [dispositivePayload, setDispositivePayload] = useState<any>(null);
  
    const deepClone = (obj: any) => {
      return JSON.parse(JSON.stringify(obj));
  }
  
        // Outcomes
      const [outcome, setOutcome] = useState<any>({
          dispositive: null,
      });
  
    const [openActionValidation, setOpenActionValidation] = useState<boolean>(false);
    const [actionValidation, setActionValidation] = useState<'dispositive' | ''>('');
    const [verifyRefetchFlag, setVerifyRefetchFlag] = useState<boolean>(false);
    const [intervalMs, setIntervalMs] = useState(3000);

    const [actionStatus, setActionStatus] = useState<any>({
          dispositive: {
              byPos: null, // null - no info, VERIFY - to be verify, SUCCESS - ok, CANCELLED - ko
              byLink: null
          }
      });
  
    const setActionState = (type: 'dispositive' | '' , subType: 'byPos' | 'byLink', state: null | 'VERIFY' | 'SUCCESS'| 'CANCELLED') => {
          if (!type) {
              return;
          }
          setVerifyRefetchFlag(false);
          setOutcome({
              dispositive: null,
          });
  
          const actSts = deepClone(actionStatus);
          actSts[type][subType] = state;
          setActionStatus(actSts);
      }
      

    const completePayment= () => {
      const data = {
        "merchantRentalId": "12345",
        "preAuthCode": "preAuthCode123",
        "preAuthStartDate": "2022-05-22",
        "cardInfo": {
          "brand": "Mastercard",
          "expDate": "1910",
          "maskedPan": "4234********1234"
        },
      
      
        "traceChainId": "8ddfdeef-c4c2-4a99-a55f-0f2e48b72772",
        "status": "PAYMENT_SUCCESSFULLY",
        "refTxReq": {
          "amount": {
                  "currency": "EUR",
                  "value": 1500
          }
        },
        "tokenValue": "34jrt44",
        "acquirerId": "Mastercard",
        "terminalId": "1234567",
        "authCode": "authCode123"
      }

      const headers = { 
        'Content-Type': 'application/json',
        'LRPP-Authorization': '9f42cfb1-9110-46d1-936a-220135a75994:620355',
        'Set-Cookie': 'JSESSIONID=C8E4B1AA8EF0725AE63CA27A9C5B0A90'
      }

      axios.put('http://k8s-istiosys-testalbi-6e025ed07b-1577967780.eu-central-1.elb.amazonaws.com/int/smartpos/operation/confirm', data, { headers, withCredentials: true })
        .then((response: any) => {
          console.log(response);
          setVerifyRefetchFlag(true)
        });
    }

    const pay = () => {
      setPayFalse(true)
    }

    
    const dispositiveQuery = useQuery(   // payByPos
    ['dispositive'],
    async () => raPreAuthPaymentDispositive(dispositivePayload), {
    enabled: false,
    onSuccess: (response) => {
      let outC = deepClone(outcome);
      outC.dispositive = response;
      setOutcome(outC);

      const ps = deepClone(actionStatus);
      ps.dispositive.byPos = 'VERIFY';
      setActionStatus(ps);
      setOpenActionValidation(true);
      // completePayment()
      setVerifyRefetchFlag(true)
    },
    onError: (error) => {
      setActionValidation('');
      dispatchGlobalData({
        type: 'SET_SNACKBAR',
        payload: {
          snackbar: {
            message: t('mobilityvoucher:addCustomer.error'),
            type: snackbarTypes.error,
            show: true,
            autoClose: true,
          }
        }
      });
    }
  })

  
  const actionVerifyQuery = useQuery({ // polling with prop enabled: true/false
    
    
    queryKey: ['verify', {operationId: !!outcome[actionValidation]?.operationId ? outcome[actionValidation].operationId : 'ND'}],
    queryFn: async () => raPreAuthPaymentVerify({operationId: !!outcome[actionValidation]?.operationId ? outcome[actionValidation].operationId : ''}),
    onSuccess: async (response: any) => {
      if (response.status === 'OK' || payFalse) {

        let dataInit = new Date();
        let dataEnd = new Date();
        dataEnd.setDate(dataEnd.getDate() + 30);
        let invoiceBody: any =  {
          correlationId: order.id,
          customerId: order.customer.sapId,
          email: order.customer.email,
          payerFirstName: order.customer.firstName,
          payerLastName: order.customer.lastName,
          language: order.customer.address.country,
          dateStart: dataInit,
          dateEnd: dataEnd,
          dealerId: order.dealerId,
          tenantId: order.tenantId,
          amount: {
            currency: "EUR",
            value: order.amount
          },
          dmsSapId: order.mobilityStore.sapId,
          operationId: response.operationId
        }
        const cloneOrder = {...order}
        Object.assign(cloneOrder, {"operationId":response.operationId})
        const payedOrder =  cloneOrder
        payedOrder.paymentDate = dataInit;
        updatePayedOrder(payedOrder).then(
          async (res) => {
            invoiceDraft(invoiceBody)
            setActionState(actionValidation, 'byPos', 'SUCCESS');
            setVerifyRefetchFlag(false);
            navigate('/mobilityvoucher/payment-order/success-payment')
          }
        );
        
      }
      else if (response.status === 'CANCELLED') {
        // // console.log('verify CANCELLED');
        // dispatchGlobalData({
        // 	type: 'SET_SNACKBAR',
        // 	payload: {
        // 		snackbar: {
        // 			message: t('error.tryLater'),
        // 			type: snackbarTypes.error,
        // 			show: true,
        // 			autoClose: true,
        // 		}
        // 	}
        // });
        navigate('/mobilityvoucher/payment-order/error-payment')
        setVerifyRefetchFlag(false);
        setActionState(actionValidation, 'byPos', 'CANCELLED');
      }
    },
    onError: (error: any) => {
      console.log("error",error);
      console.log('dispositive',outcome);
      dispatchGlobalData({
        type: 'SET_SNACKBAR',
        payload: {
          snackbar: {
            message: t('mobilityvoucher:addCustomer.error'),
            type: snackbarTypes.error,
            show: true,
            autoClose: true,
          }
        }
      });
      setVerifyRefetchFlag(false)
    },
    // Refetch the data every interval
    refetchInterval: intervalMs,
    enabled: verifyRefetchFlag
  })
  
  const buildPayPreAuthPayload = () => {
    let dataInit = new Date();
    let dataEnd = new Date();
    dataEnd.setDate(dataEnd.getDate() + 30);
    if (order.customer.customerType === 'Organization') {
      let payload: any =  {
        correlationId: order.id,
        customerId: order.customer.sapId,
        email: order.customer.email,
        payerFirstName: order.customer.companyName,
        payerLastName: order.customer.vatNumber,
        language: order.customer.address.country,
        dateStart: dataInit,
        dateEnd: dataEnd,
        dealerId: order.dealerId,
        tenantId: order.tenantId,
        amount: {
          currency: "EUR",
          value: order.amount
        },
      }

      return payload
    } else {
      let payload: any =  {
        correlationId: order.id,
        customerId: order.customer.sapId,
        email: order.customer.email,
        payerFirstName: order.customer.firstName,
        payerLastName: order.customer.lastName,
        language: order.customer.address.country,
        dateStart: dataInit,
        dateEnd: dataEnd,
        dealerId: order.dealerId,
        tenantId: order.tenantId,
        amount: {
          currency: "EUR",
          value: order.amount
        },
      }

      return payload
    }
    
  
  }
  
  /**
       * Pay By Pos
       */
   const handlePayByPos = () => {
    // e.stopPropagation();
  
    setDispositivePayload(buildPayPreAuthPayload());
    setActionValidation('dispositive');
  }
  
    // const handlePayByPos = () => {
    //   const payedOrder = order
    //   console.log(payedOrder);
      
    //   updatePayedOrder(payedOrder)
    //       .then(function (response) {
    //           navigate('/mobilityvoucher/orders')
    //           dispatchGlobalData({
    //               type: 'SET_SNACKBAR',
    //               payload: {
    //                 snackbar: {
    //                   message: t('mobilityvoucher:message.orderPay'),
    //                   type: snackbarTypes.success,
    //                   show: true,
    //                   autoClose: true,
    //                 }
    //               }
    //           });
    //       })
    //       .catch(() => {
    //           dispatchGlobalData({
    //               type: 'SET_SNACKBAR',
    //               payload: {
    //                 snackbar: {
    //                   message: t('mobilityvoucher:addCustomer.error'),
    //                   type: snackbarTypes.error,
    //                   show: true,
    //                   autoClose: true,
    //                 }
    //               }
    //           });
    //       })
    // }
  
  useEffect( () => {
    if (!!dispositivePayload) {
      dispositiveQuery.refetch();
    }
  }, [dispositivePayload]); // OK status code
  
  useEffect(() => {
    handlePayByPos();
}, []);
  
  // const handleCloseActionValidation = () => {
  //   setActionValidation('');
  //   setDispositivePayload(null);
  //   setVerifyRefetchFlag(false);
  //   setOpenActionValidation(false);
  // }
  
    return (
      <>
        <div style={{ display: 'flex', flexDirection: 'column', paddingTop: '110px', paddingBottom: '230px', justifyContent: 'center', alignItems: 'center' }}>
          {!!outcome[actionValidation]?.qrCode &&
          <>
            <Grid sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>

              <Typography sx={{my: theme.spacing(2)}} variant={"h4"} >
                  {t('stepper.paymentValidation')}
              </Typography>

              <CircularProgress size={24} sx={{mx: theme.spacing(1)}}/>
            </Grid>

            <QRCode
                size={256}
                style={{ height: "auto", maxWidth: "400px" }}
                value={outcome[actionValidation]?.qrCode}
                viewBox={`0 0 128 128`}
            />

              <Typography sx={{my: theme.spacing(2)}} variant={"bodySmall"} >
                        <strong>
                            {outcome[actionValidation]?.qrCode}
                        </strong>
              </Typography>
              {/* Button Test */}
              {/* <Button sx={{mt: "10px"}} onClick={pay} variant='outlined'>{'pay'}</Button> */}
            </>
          }
          {!outcome[actionValidation]?.qrCode &&
            <>
              <CircularProgress size={60} />
              <h4>{t("checkout.spinnerMessage")}</h4>
              <h5>{t("checkout.waitingMessage")}</h5>
            </>
          }
          <Button sx={{mt: "10px"}} onClick={goToHome} variant='outlined'>{t("buttons.cancel")}</Button>
        </div>
      </>
    );
  };